module.exports = __webpack_public_path__ + "img/mbbr.a21b299d.jpg";